import { render, staticRenderFns } from "./scope-header-actions.vue?vue&type=template&id=5fc0240f&scoped=true"
import script from "./scope-header-actions.ts?vue&type=script&lang=ts&external"
export * from "./scope-header-actions.ts?vue&type=script&lang=ts&external"
import style0 from "./scope-header-actions.less?vue&type=style&index=0&id=5fc0240f&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc0240f",
  null
  
)

export default component.exports